module.exports = __webpack_public_path__ + "img/step1-b.f7244a26.png";